import { combineReducers } from "redux";

import theme from "./theme";
import auth from "./auth";
import data from "./data";
import subscription from "./subscription";
import store from "./store";

export default combineReducers({
    theme,
    auth,
    data,
    subscription,
    store,
});
